import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import PageHero from "@/components/PageHero";
import { Reveal, Overline } from "@/components/Reveal";
import { GALLERY } from "@/data/content";

const FILTERS = ["All", "Living Room", "Pooja Unit", "Dining", "Modular Kitchen", "Bedroom", "Bathroom"];

export default function Gallery() {
  const [filter, setFilter] = useState("All");
  const items = filter === "All" ? GALLERY : GALLERY.filter((g) => g.cat === filter);

  return (
    <div data-testid="gallery-page">
      <PageHero
        overline="Gallery"
        title={<>Spaces That <span className="text-gold-gradient italic">Speak.</span></>}
        subtitle="A glimpse of our showroom, projects and products. More photography is being added regularly."
        image="/photos/living/5.webp"
      />

      <section className="py-14 md:py-20">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <div className="flex flex-wrap gap-3 mb-12">
            {FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`gallery-filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setFilter(f)}
                className={`px-6 py-2.5 text-xs uppercase tracking-[0.2em] border transition-colors duration-300 ${
                  filter === f ? "bg-[#e7c15a] border-[#e7c15a] text-[#050505]" : "border-white/15 text-[#b8b8b8] hover:border-[#e7c15a] hover:text-[#e7c15a]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            <AnimatePresence mode="popLayout">
              {items.map((g, i) => (
                <motion.div
                  key={g.src}
                  layout
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                  data-testid={`gallery-item-${i}`}
                  className={`group relative overflow-hidden border border-white/10 ${i % 5 === 0 ? "sm:col-span-2 aspect-[16/10]" : "aspect-[4/3]"}`}
                >
                  <img src={g.src} alt={g.label} loading="lazy" className="img-lux h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/95 via-[#0a0a0a]/10 to-transparent opacity-55 group-hover:opacity-85 transition-opacity" />
                  <div className="absolute bottom-0 left-0 p-6 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                    <span className="text-[10px] uppercase tracking-[0.25em] text-[#e7c15a]">{g.cat}</span>
                    <h3 className="font-serif-lux text-2xl text-[#fafafa] mt-1">{g.label}</h3>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

          <Reveal delay={0.1}>
            <p className="mt-14 text-center text-sm text-[#666]">Showroom, project & product photography — updated regularly.</p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
